import { Injectable } from '@angular/core';
import { AppSettingsService } from './app-settings.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { hd } from './helpdesk.typings';
import { HttpService } from './http.service';

type IDeviceModel = hd.IDeviceModel;

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private http: HttpService, private appSettings: AppSettingsService) {}

  getDevice(deviceId: string, isForRc?: boolean): Observable<IDeviceModel> {
    const params: { [key: string]: string } = {};
    if (!!isForRc) {
      params.isForRc = isForRc.toString();
    }
    return this.http.get<IDeviceModel>(this.appSettings.deviceServiceUrl + deviceId, { params }).pipe(
      map(deviceModel => {
        if (deviceModel) {
          return deviceModel;
        }
        throw new Error('error_no_device_info');
      })
    );
  }

  getDevicesByMcId(mcId: number, deviceIds?: string, isForRc?: boolean): Observable<IDeviceModel[]> {
    const params: { [key: string]: string } = { deviceIds, mcConnectionId: mcId.toString() };
    if (!!isForRc) {
      params.isForRc = isForRc.toString();
    }

    return this.http.get<IDeviceModel[]>(this.appSettings.deviceServiceUrl, { params });
  }

  getDevices(deviceIds?: string, isForRc?: boolean): Observable<IDeviceModel[]> {
    const params: { [key: string]: string } = { deviceIds };
    if (!!isForRc) {
      params.isForRc = isForRc.toString();
    }

    return this.http.get<IDeviceModel[]>(this.appSettings.deviceServiceUrl, { params });
  }
}
